import { BccPage } from '../modules/bcc/BccPage'

export function HomePage() {
  return <BccPage />
}
